import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const BulkActionModal = ({ show, onHide, onConfirm, action, count }) => {
  const [remark, setRemark] = useState("");
  const [error, setError] = useState("");

  const handleConfirm = () => {
    // Validate remark is not empty
    if (!remark.trim()) {
      setError("Remark is mandatory for bulk action");
      return;
    }

    // Clear error and call parent confirm function
    setError("");
    onConfirm(remark);
    
    // Reset state
    setRemark("");
  };

  const handleClose = () => {
    setRemark("");
    setError("");
    onHide();
  };

  const actionText = action === "approve" ? "Approve" : "Reject";
  const actionVariant = action === "approve" ? "success" : "danger";

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Bulk {actionText}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          You are about to <strong>{actionText.toLowerCase()}</strong>{" "}
          <strong>{count}</strong> regularization request(s).
        </p>
        
        <Form.Group className="mt-3">
          <Form.Label>
            Approver Remark <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder={`Enter remark for bulk ${actionText.toLowerCase()}...`}
            value={remark}
            onChange={(e) => {
              setRemark(e.target.value);
              if (error) setError(""); // Clear error on input
            }}
            isInvalid={!!error}
          />
          <Form.Control.Feedback type="invalid">
            {error}
          </Form.Control.Feedback>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant={actionVariant} onClick={handleConfirm}>
          Confirm {actionText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BulkActionModal;